export default "./icons/moon.png";